/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type StairsTypeEnum = 1 | 2 | 3 | 4;

export const StairsTypeEnum = {
    NUMBER_1: 1 as StairsTypeEnum,
    NUMBER_2: 2 as StairsTypeEnum,
    NUMBER_3: 3 as StairsTypeEnum,
    NUMBER_4: 4 as StairsTypeEnum
};

